import $http from '@/libs/axios'

class CouponAPIs {
  static async verify(code: string, current_package: string, target_package: string, branch_id: number) {
    return (await $http.post('/coupons/verify', {
      code, current_package, target_package, branch_id,
    })).data
  }

  static async verifyOrderCoupon(couponCode: string, amount: number, phoneNumber = null, order_ids = null, branch_id = null, item_ids: any, selling_types: any) {
    const data = {
      code: couponCode,
      amount,
      branch_id,
      order_ids,
      item_ids,
      phoneNumber,
      selling_types,
    }
    return (await $http.post('promotions/coupons/verify', data))?.data
  }
}

export default CouponAPIs
